import { DataTableCellContent, DataTableProps } from '../types';

export const paginateData = <T extends string>(
  data: DataTableCellContent<T>[],
  pagination: DataTableProps<T>['pagination'],
  page: number
): DataTableCellContent<T>[] => {
  const rowsPerPage = pagination ?? data.length;

  const start = Math.max((page - 1) * rowsPerPage, 0);
  const end = Math.min(page * rowsPerPage, data.length);
  return data.slice(start, end);
};
